export const getRoomMain = (state) => state.objectRoomEdit.roomMain

export const getRoomPhotoApprovedToDB = (state) => state.objectRoomEdit?.photos?.photos